import React, { useState } from "react";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
import "../../styles/Contact.css";

export default function Contact() {
  const [popup, setPopup] = useState(null);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    if (!captchaVerified) {
      setPopup({
        type: "error",
        message: "Please complete the reCAPTCHA verification.",
      });
      return;
    }

    const form = e.target;
    const now = new Date().toLocaleString();
    form.querySelector('input[name="time"]').value = now;

    emailjs
      .sendForm(
        "service_91t1e08", // ✅ EmailJS service ID
        "template_3h8wee8", // ✅ Template ID
        form,
        "aQspRnFyNb56cNcu4" // ✅ Public key
      )
      .then(
        () => {
          setPopup({
            type: "success",
            message: "Your email has been sent successfully!",
          });
          form.reset();
          setCaptchaVerified(false); // reset captcha
        },
        (error) => {
          setPopup({
            type: "error",
            message: "Failed to send message. Please try again.",
          });
          console.error(error);
        }
      );
  };

  return (
    <section className="section">
      <div className="contact-grid" style={{ marginTop: "60px" }}>
        <div className="contact-info">
          <h1 className="contact-title">Contact</h1>
          <p className="contact-subtext">
            Have a question or need assistance? Reach out to us.
          </p>
          <div className="card">
            <div>ali.alromeh@javelynx.com</div>
            <div>+33 7 71 82 96 92</div>
            <div>+961 70 965 968</div>
            <div>France • Lebanon</div>
          </div>
        </div>

        <form className="card contact-form" onSubmit={sendEmail}>
          <input type="hidden" name="time" />

          <label>
            <span>Name</span>
            <input type="text" name="name" required />
          </label>
          <label>
            <span>Email</span>
            <input type="email" name="email" required />
          </label>
          <label>
            <span>Phone</span>
            <input
              type="tel"
              name="phone"
              pattern="^\+?[0-9\s-]{7,15}$"
              required
            />
          </label>
          <label>
            <span>Company</span>
            <input type="text" name="company" />
          </label>
          <label>
            <span>Message</span>
            <textarea name="message" required />
          </label>

          {/* ✅ reCAPTCHA */}
          <ReCAPTCHA
            sitekey="6LeLUs0rAAAAAM6kbRokTwtP6bUtrGE-L3De5u4N" // replace with your site key
            onChange={() => setCaptchaVerified(true)}
          />

          <button type="submit" className="btn-primary">
            Send message
          </button>
        </form>
      </div>

      {/* ✅ Popup */}
      {popup && (
        <div className="popup-overlay" onClick={() => setPopup(null)}>
          <div
            className={`popup-box ${
              popup.type === "success" ? "popup-success" : "popup-error"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="popup-icon">
              {popup.type === "success" ? "✅" : "❌"}
            </div>
            <p>{popup.message}</p>
            <button onClick={() => setPopup(null)}>OK</button>
          </div>
        </div>
      )}
    </section>
  );
}
